import { SiteIdOverrideConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-new-date-picker";

export const siteId9: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://forever.travel-assets.com/flex/flexmanager/images/2020/06/25/EU_quiraing_ex.jpg",
  },
  hotel: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  flight: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  package: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  car: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
    driveAgeCheckbox: true,
  },
  lx: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
};
